import React, { useState, useEffect, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Spinner, Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faWrench,
    faAsterisk,
    faCheck,
    faTimes,
    faClock,
} 
from '@fortawesome/free-solid-svg-icons'
import { Pie } from 'react-chartjs-2';
import { taskDashboard } from '../Network/Dashboard'
import { listRepairType } from '../Network/Repair'
import { NotifyContext } from '../Library/Notify'
import { LanguageContext } from '../Language/LanguageContext'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FilterListIcon from '@material-ui/icons/FilterList';

export default function TaskSection(props){
    const [isLoading, setLoading] = useState(false)
    const [tasks, setTasks] = useState([])
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.home
    const notifyCx = useContext(NotifyContext)
    //const tasks = props.tasks
    const taskData = [tasks?.create || 0, tasks?.waiting || 0, tasks?.in_progress || 0, tasks?.complete || 0, tasks?.cancel || 0]

    const [checked, setChecked] = React.useState(false);
    const [isFilter, setIsFilter] = React.useState(false);

    const [repairList, setRepairList] = useState([]);
    const [selectRepair, setSelectRepair] = useState(null);
    const [filtertask, setfiltertask] = React.useState([]);
    const filtertaskData = [filtertask?.create || 0, filtertask?.waiting || 0, filtertask?.in_progress || 0, filtertask?.complete || 0, filtertask.cancel || 0]
    
    useEffect(()=>{
        setLoading(true)
        listRepairType(
            (data)=>{
                setRepairList(data)
            },
            (error)=>{ }
        )

        taskDashboard(null,
            (data)=>{
                setTasks(data)
                setLoading(false)
            },
            (error)=>{
                setLoading(false)
            })
    },[])

    const setfilterdashboard = (id) =>{
        setLoading(true)
        taskDashboard(id,
            (data)=>{
                setfiltertask(data)
                setIsFilter(true)
                setLoading(false)
            },
            (error)=>{
                notifyCx.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const data = {
        labels: [lang.created, lang.waiting, lang.in_progress, lang.complete, lang.cancelled],
        datasets: [{
            data: taskData,
            backgroundColor: [
                '#bc1b1b',
                '#efb729',
                '#3a88bc',
                '#83d03b',
                '#9d9da7',
            ]
        }]
    }

    const filter_data = {
        labels: [lang.created, lang.waiting, lang.in_progress, lang.complete, lang.cancelled],
        datasets: [{
            data: filtertaskData,
            backgroundColor: [
                '#bc1b1b',
                '#efb729',
                '#3a88bc',
                '#83d03b',
                '#9d9da7',
            ]
        }]
    } 

    return(
        <div className="section">
            { isLoading ?
            <div className="loading-section">
                <Spinner 
                variant="primary" 
                animation="border"
                size="sm"
                />
            </div> : null
            }
            <div className="section-title">
                {lang.task}
                <IconButton 
                    aria-label="filter" 
                    size="small" 
                    color="primary"
                    onClick={() => {
                        setChecked(!checked ? true : false)
                        setIsFilter(false)
                        setSelectRepair(null)
                    }}
                    style={{marginLeft: 10}}
                >
                <FilterListIcon fontSize="inherit" />
                </IconButton>

                { checked ?
                <>
                <div className = "filterbutton">
                    <Button 
                        className="button"
                        variant="outlined" 
                        color="primary"
                        size="small"    
                        onClick={()=>{
                            setSelectRepair(null)
                            setIsFilter(false)
                            
                            //setfilterdashboard(item.id)
                        }}
                        style={{ 
                            color: selectRepair === null ? "white" : "#00275e",
                            backgroundColor: selectRepair === null ? "#00275e": "white"
                        }} 
                    >
                            {lang.all}
                    </Button>
                { repairList.map((item, key)=>
                    <Button 
                        key={key}
                        className="button"
                        variant="outlined" 
                        color="primary"
                        size="small"    
                        onClick={()=>{
                            setSelectRepair(item.id)
                            setfilterdashboard(item.id)
                        }}
                        style={{ 
                            color: selectRepair === item.id ? "white" : "#00275e",
                            backgroundColor: selectRepair === item.id ? "#00275e": "white"
                        }} 
                    >
                            {langCx.code === "th" ? item.name : item.nameEn}
                    </Button>
                )}
                </div>
                </>
                :null
                }

            </div>
            <div>
                <div className="chart-container">
                    <Pie data={isFilter ? filter_data : data} options={{ maintainAspectRatio: false }}/>
                </div>
                <Row className="stat-container" style={{marginTop:20}}>
                    <Col className="item" xs={4}>
                        <StatItem 
                        title={lang.all_task} 
                        number={ isFilter ?
                            filtertaskData.reduce((total, num)=>total+num) :
                            taskData.reduce((total, num)=>total+num)
                        }
                        icon={faWrench}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem 
                        title={lang.new_task} 
                        number={ isFilter ?
                            filtertask.create || 0 :
                            tasks.create || 0}
                        icon={faAsterisk}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.waiting}
                        number={ isFilter ?
                            filtertask.waiting || 0 :
                            tasks.waiting || 0
                        }
                        icon={faClock}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.in_progress}
                        number={ isFilter ?
                            filtertask.in_progress || 0 :
                            tasks.in_progress || 0
                        }
                        icon={faClock}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.complete}
                        number={ isFilter ?
                            filtertask.complete || 0 :
                            tasks.complete || 0
                        }
                        icon={faCheck}
                        />
                    </Col>
                    <Col className="item" xs={4}>
                        <StatItem
                        title={lang.cancelled}
                        number={ isFilter ?
                            filtertask.cancel || 0 :
                            tasks.cancel || 0
                        }
                        icon={faTimes}
                        />
                    </Col>
                </Row>
                <div style={{marginTop: 20, textAlign: 'center'}}>
                    <Link to="/repair" className="link-section">
                        {lang.see_more_task}
                    </Link>
                </div>
            </div>
        </div>
    )
}

function StatItem({ title, number, icon }){
    return(
        <div>
            <div className="number">
                { number.toLocaleString() }
            </div>
            <div className="title">
                <FontAwesomeIcon icon={icon} style={{marginRight: 5}}/>
                {title}
            </div>
        </div>
    )
}